<ng-container *transloco="let t; prefix: 'fuelChanges'">
@if (isPageInitialized) {
  <div
    class="dashboard-top-section d-flex align-items-center justify-content-between">
    <h1>{{ t('title') }}</h1>

    <div class="search-menu-lists d-flex fuelChangesList">
      <div class="filters d-flex align-items-center gap-2">
        <app-account-filter
          [filter]="accountFilter"
          (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

        <div class="datelisting">
          <div class="common-drop-down dropdown">
            <app-date-filter
              [filter]="dateFilter"
              [isButtonIntervalSelector]="false"
              [disabledIntervals]="disabledIntervals"
              [defaultInterval]="defaultInterval"
              (filterChanged)="onDateFilterChange($event)">
            </app-date-filter>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<div class="dashboard-box">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-total-fuel-loss-widget
        [selectedFilter]="getSelectedFilterLabel(dateFilter)"
        [dateFilter]="dateFilter"
        [modalFilterHeaders]="
          getModalFilterHeaders(dateFilter)
        "></app-total-fuel-loss-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-total-fill-ups-widget
        [selectedFilter]="getSelectedFilterLabel(dateFilter)"
        [accountFilter]="accountFilter"
        [dateFilter]="dateFilter"
        [modalFilterHeaders]="getModalFilterHeaders(dateFilter)">
      </app-total-fill-ups-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-loss-ratio-widget
        [selectedFilter]="getSelectedFilterLabel(dateFilter)"
        [accountFilter]="accountFilter"
        [dateFilter]="dateFilter"
        [modalFilterHeaders]="getModalFilterHeaders(dateFilter)">
      </app-loss-ratio-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <app-fuel-consumption-widget
        [selectedFilter]="getSelectedFilterLabel(dateFilter)"
        [accountFilter]="accountFilter"
        [dateFilter]="dateFilter"
        [modalFilterHeaders]="getModalFilterHeaders(dateFilter)">
			</app-fuel-consumption-widget>
    </div>
  </div>
</div>

<div class="bottom-grid-section">
  <div class="bottom-grid-sec-left">
    <div class="filter-container pb-3 d-flex w-full justify-content-between">
      <div class="w-50">
        <app-search
          [placeholder]="'accountFilter.search' | transloco"
          [disabled]="isLoading || isExporting"
          (searchTermUpdated)="onSearchTermUpdate($event)"
          customWidth ="100%">
        </app-search>
      </div>

      <div class="d-flex align-items-center gap-2">
        <app-driver-filter
          [filter]="driverFilter"
          [accountFilterChanged$]="accountFilterChanged$"
          (filterChanged)="onDriverFilterChange($event)">
        </app-driver-filter>

        <span ngbDropdown [autoClose]="true">
          <button
            type="button"
            class="btn fuel-change-type-filter form-control dropdown-toggle search-input"
            [disabled]="isLoading"
            id="fuelChangesFilterDropdown"
            ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between">
              <span class="align-middle">{{
                (fuelChangeType === fuelChangeTypeFilter.All ? 'common.all' : fuelChangeType === fuelChangeTypeFilter.Increases ? 'fuelChanges.filters.increases' : 'fuelChanges.filters.decreases') | transloco
              }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>
          <div ngbDropdownMenu aria-labelledby="fuelChangesFilterDropdown">
            <div class="d-flex flex-column">
              <button
                class="btn btn-outline"
                (click)="onFuelChangeTypeFilter(fuelChangeTypeFilter.All)"
                ngbDropdownItem>{{ 'common.all' | transloco }}</button>
              <button
                class="btn btn-outline"
                (click)="onFuelChangeTypeFilter(fuelChangeTypeFilter.Increases)"
                ngbDropdownItem>
                {{ t('filters.increases') }}
              </button>
              <button
                class="btn btn-outline"
                (click)="onFuelChangeTypeFilter(fuelChangeTypeFilter.Decreases)"
                ngbDropdownItem>
                {{ t('filters.decreases') }}
              </button>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="main-table fuel-changes-table">
      <table class="table" [class.show-last-border]="showLastRowBorder">
        <thead>
          <tr>
            <th class="vehicle">{{ t('table.vehicle') }}</th>
            <th class="driver">{{ t('table.driver') }}</th>
            <th class="location">{{ t('table.location') }}</th>
            <th class="amount">{{ t('table.amount') }}</th>
            <th class="type">{{ t('table.type') }}</th>
            <th class="cost">{{ t('table.cost') }}</th>
            <th class="expand-icon">{{ t('table.action') }}</th>
          </tr>
        </thead>
        @if (isLoading || isLoadingLocations) {
          <tbody
            class="spinner-container d-flex align-items-center justify-content-center spinner-border"></tbody>
        }
        @if (!isLoading && !isLoadingLocations) {
          <tbody>
            @if (!fuelChangesDetails?.length) {
              <div class="driver-status-table__no-data">
                <span class="table__no-data">
                  <app-empty-state></app-empty-state>
                </span>
              </div>
            }
            @for (row of fuelChangesDetails; track index; let index = $index) {
              <ng-container>
                <!-- class="active-table" -->
                <tr (click)="tableRowOpen(row, index)">
                  <td class="vehicle">
                    <p>{{ row.vehicle }}</p>
                  </td>
                  <td class="driver">
                    <p class="driver-name">{{ row.driver }}</p>
                  </td>
                  <td class="location">
                    <a
                      href="javascript:void(0)"
                      class="location-link"
                      (click)="onLocationClick(row, $event)">
                      {{ row.location }}
                    </a>
                  </td>
                  <td class="amount">
                    <div class="d-flex flex-column w-100 gap-1">
                      <p
                        [ngClass]="{
                          increase: row.type === 'Fill-Up',
                          decrease: row.type === 'Loss',
                        }">
                        {{
                          row.type === 'Loss' ? '-' + row.amount : row.amount
                        }}
                        ℓ
                      </p>
                      @if (row.tank > 0) {
                        <p class="subscript">{{ t('table.tank', { number: row.tank }) }}</p>
                      }
                    </div>
                  </td>
                  <td class="type">
                    <div class="d-flex flex-column w-100 gap-1">
                      <p>{{ row.type === 'Fill-Up' ? t('types.fillUp') : row.type === 'Loss' ? t('types.loss') : row.type }}</p>
                      <p class="subscript">
                        {{ row.timestamp | date: 'dd/MM/yyyy HH:mm' }}
                      </p>
                    </div>
                  </td>
                  <td class="cost">
                    <p>{{ formatCost(row.cost) }}</p>
                  </td>
                  <td class="expand-icon">
                    <img
                      src="assets/icons/icon-chevron-down.svg"
                      alt="expand"
                      [class.rotated]="shouldRotateExpandIcon(index, page)" />
                  </td>
                </tr>

                <!-- details row -->
                @if (expandedRow === getRowKey(row, index)) {
                  <tr class="show-table-row">
                    <td colspan="8">
                      <table class="detail-table w-100">
                        <thead>
                          <tr>
                            <th>{{ t('table.vehicle') }}</th>
                            <th>{{ t('table.fuelLevelBeforeChange') }}</th>
                            <th>{{ t('table.fuelLevelAfterChange') }}</th>
                            <th>{{ t('table.fuelConsumption') }}</th>
                            @if (row.type === 'Loss') {
                              <th>{{ t('table.action') }}</th>
                            }
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ row.vehicle }}</td>
                            <td>{{ getFuelLevelBeforeDisplay(row) }}</td>
                            <td>{{ getFuelLevelAfterDisplay(row) }}</td>
                            <td>
                              {{
                                row.fuelConsumption
                                  ? row.fuelConsumption + ' ℓ/100 Km'
                                  : t('table.notAvailable')
                              }}
                            </td>
                            @if (row.type === 'Loss') {
                              <td>
                                <button
                                  class="common-button"
                                  (click)="
                                    openInvestigationModal(row);
                                    $event.stopPropagation()
                                  ">
                                  {{ t('table.investigate') }}
                                </button>
                              </td>
                            }
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                }
              </ng-container>
            }
          </tbody>
        }
      </table>
    </div>

    <div
      class="d-flex align-items-center justify-content-between bottom-options">
      <p class="pagination-text">
        {{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}
      </p>

      <app-pagination
        [totalPages]="totalPages"
        [currentPage]="page"
        (pageChange)="goToPage($event)">
      </app-pagination>

      <div
        ngbDropdown
        #exportDropdown="ngbDropdown"
        class="export-listing"
        [autoClose]="true"
        placement="top-end">
        <div class="common-drop-down dropdown">
          <button
            class="btn btn-secondary dropdown-toggle d-flex align-items-center gap-2"
            type="button"
            id="dropdown-button"
            ngbDropdownToggle
            [disabled]="isLoading || isExporting">
            @if (isExporting) {
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"></span>
            }
            <span>{{ isExporting ? t('export.exporting') : ('common.export' | transloco) }}</span>
            @if (!isExporting) {
              <i>
                <img
                  src="./assets/images-fuel/downloadIcon.svg"
                  alt="export-icon" />
              </i>
            }
          </button>

          <ul
            ngbDropdownMenu
            class="dropdown-menu export-menu"
            aria-labelledby="dropdown-button">
            <li>
              <a
                ngbDropdownItem
                class="dropdown-item"
                style="cursor: pointer"
                (click)="exportDropdown.close(); exportFuelChangesExcel()">
                {{ t('export.exportAsExcel') }}
              </a>
            </li>
            <li>
              <a
                ngbDropdownItem
                class="dropdown-item"
                style="cursor: pointer"
                (click)="exportDropdown.close(); exportFuelChangesCSV()">
                {{ t('export.exportAsCsv') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-grid-sec-right">
    <app-fuel-changes-map
      [mapCenter]="mapCenter"
      [isLoading]="isLoadingLocations"></app-fuel-changes-map>
  </div>
</div>
</ng-container>
